import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
// import "../assets/css/Password.css"; // Ensure this path is correct
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import SecurityHeaders from "../../context/SecurityHeaders";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";

const OtpPage = ({ email, userPhone }) => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [timerActive, setTimerActive] = useState(true);
  const [resendCount, setResendCount] = useState(0);
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({});
  const [visibility, setVisibility] = useState(false);
  const [conformvisibility, setConformVisibility] = useState(false);

  const inputRefs = useRef([]);
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const codeRef = useRef();
  const navigate = useNavigate();

  // Timer effect
  useEffect(() => {
    if (!timerActive) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          setTimerActive(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timerActive]);

  // Redirect to home page after 5 seconds on checkmail page
  useEffect(() => {
    if (success) {
      const redirectTimer = setTimeout(() => {
        navigate("/");
      }, 3000); // 3 seconds delay
      return () => clearTimeout(redirectTimer); // Cleanup on unmount
    }
  }, [success, navigate]);

  const handleChange = (index, value) => {
    if (value.length <= 1 && /^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setError("");

      if (value && index < 5) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        inputRefs.current[index - 1]?.focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = "";
        setOtp(newOtp);
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (e.key === "ArrowRight" && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const getOtpDisplay = () => otp.join("");

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").replace(/\D/g, "");
    const otpArray = pastedData.split("").slice(0, 6);

    while (otpArray.length < 6) {
      otpArray.push("");
    }

    setOtp(otpArray);
  };

  const handleVerify = async () => {
    const otpValue = otp.join("");
    if (otpValue.length !== 6) {
      setError("Please enter the complete 6-digit code");
      return;
    }

    setIsLoading(true);
    setError("");

    setTimeout(() => {
      if (otpValue === "123456") {
        setSuccess(true);
      } else {
        setError("Invalid verification code. Please try again.");
      }
      setIsLoading(false);
    }, 1500);
  };

  const handleResend = () => {
    setResendCount((prev) => prev + 1);
    setTimerActive(true);
    setTimeLeft(30);
    setOtp(new Array(6).fill(""));
    setError("");
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };
  const userPhonenu = localStorage.getItem("userPhone") || userPhone;

  const changePassword = async (event) => {
    if (event) event.preventDefault();
    const data = new FormData();
    data.append("email", localStorage.getItem("userEmail") || email);
    data.append("password", passwordRef.current?.value || "");
    data.append("confirmPassword", confirmPasswordRef.current?.value || "");
    data.append("code", otp.join("") || "");

    // Basic password validation
    if (passwordRef.current?.value !== confirmPasswordRef.current?.value) {
      setError("Passwords do not match");
      return;
    }
    
    if (!passwordRef.current?.value || passwordRef.current?.value.length < 6) {
      setError("Password must be at least 6 characters long");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const res = await axios.post("https://siliconmindstechnologies.com/change-pasword.php",
        data,
        SecurityHeaders
      );
      if (res && res.data[0].status === "success") {
        setSuccess(true);
        navigate("/password-success");
      } else {
        setError("Failed to change password. Please try again.");
      }
    } catch (error) {
      console.error("Error in changePassword:", error);
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePasswordChange = () => {
    console.log("handlePasswordChange");
  };

  const toggleVisibility = () => {
    setVisibility(!visibility);
  };

  const toggleConformVisibility = () => {
    setConformVisibility(!conformvisibility);
  };

  if (success) {
    return (
      <div className="otp-bg">
        <Container
          fluid
          className="min-vh-100 d-flex align-items-center justify-content-center"
        >
          <Row className="justify-content-center w-100">
            <Col xs={11} sm={8} md={6} lg={4}>
              <Card
                style={{
                  backdropFilter: "blur(24px)",
                  WebkitBackdropFilter: "blur(24px)",
                }}
                className="otp-glass-card shadow-lg border-0"
              >
                <Card.Body className="p-5 text-center">
                  <div className="mb-4 otp-header-anim">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-10 p-3 mb-3"
                      style={{ width: "80px", height: "80px" }}
                    >
                      <i
                        className="bi bi-check-circle-fill text-success"
                        style={{ fontSize: "2.5rem" }}
                      ></i>
                    </div>
                  </div>
                  <h2 className="fw-bold text-dark mb-3">
                    Password Changed Successfully!
                  </h2>
                  <p className="text-muted mb-4">
                    Your password has been updated. Redirecting to home page in
                    5 seconds...
                  </p>
                  <Button
                    variant="primary"
                    size="lg"
                    className="w-100 py-3 fw-semibold otp-btn-anim"
                    style={{ borderRadius: "12px" }}
                    onClick={() => navigate("/")}
                  >
                    Go to Home Now
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
        position: "relative",
        overflow: "hidden",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      }}
      className="otp-bg"
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            top: "5rem",
            left: "5rem",
            width: "8rem",
            height: "8rem",
            background:
              "linear-gradient(135deg, rgba(60, 7, 185, 0.2) 0%, rgba(54, 0, 141, 0.2) 100%)",
            animationDelay: "0s",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            top: "10rem",
            right: "8rem",
            width: "6rem",
            height: "6rem",
            background:
              "linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(139, 92, 246, 0.15) 100%)",
            animationDelay: "1s",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            bottom: "8rem",
            left: "8rem",
            width: "7rem",
            height: "7rem",
            background:
              "linear-gradient(135deg, rgba(168, 85, 247, 0.2) 0%, rgba(236, 72, 153, 0.2) 100%)",
            animationDelay: "2s",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            borderRadius: "50%",
            filter: "blur(40px)",
            animation: "float 6s ease-in-out infinite",
            bottom: "5rem",
            right: "5rem",
            width: "9rem",
            height: "9rem",
            background:
              "linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)",
            animationDelay: "3s",
          }}
        ></div>

        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              width: "0.75rem",
              height: "0.75rem",
              background:
                "linear-gradient(135deg, rgba(139, 92, 246, 0.3) 0%, rgba(168, 85, 247, 0.3) 100%)",
              borderRadius: "50%",
              filter: "blur(2px)",
              animation: "pulse 3s ease-in-out infinite",
              top: `${10 + ((i * 7) % 80)}%`,
              left: `${5 + ((i * 11) % 90)}%`,
              animationDelay: `${i * 200}ms`,
              animationDuration: `${2000 + i * 100}ms`,
            }}
          />
        ))}
      </div>
      <Container
        fluid
        className="min-vh-100 d-flex align-items-center justify-content-center my-5"
      >
        <Row className="justify-content-center">
          <Col xs={12} sm={12} md={6} lg={12}>
            <Card className="otp-glass-card shadow-lg border-0">
              <Card.Body className="p-5">
                <div className="d-flex align-items-center justify-content-between mb-4 otp-header-anim">
                  <Button
                    variant="light"
                    className="p-2 border-0"
                    style={{ borderRadius: "10px" }}
                    onClick={() => (window.location.href = "/forgot-page")}
                  >
                    <i
                      style={{
                        height: "30px",
                        fontSize: "30px",
                        color: "#007bff",
                      }}
                      className="bi bi-arrow-left text-muted"
                    ></i>
                  </Button>
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 p-3"
                    style={{ width: "60px", height: "60px" }}
                  >
                    <i
                      className="bi bi-shield-check text-primary"
                      style={{ fontSize: "1.5rem" }}
                    ></i>
                  </div>
                  <div style={{ width: "40px" }}></div>
                </div>
                <div className="text-center mb-4">
                  <h2 style={{ color: "orange" }} className="fw-bold mb-3">
                    Verify Your Phone
                  </h2>
                  <p className="text-muted">
                    We've sent a 6-digit verification code to
                    <br />
                    <span className="fw-semibold text-dark">{userPhonenu}</span>
                  </p>
                </div>

                <div className="mb-4 mt-3 otp-input-anim">
                  <Row className="justify-content-center g-2">
                    {otp.map((digit, index) => (
                      <Col key={index} xs="auto">
                        <Form.Control
                          ref={(el) => (inputRefs.current[index] = el)}
                          type="text"
                          inputMode="numeric"
                          pattern="\d*"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChange(index, e.target.value)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          onPaste={handlePaste}
                          disabled={isLoading}
                          className={`text-center fw-semibold border-2 ${
                            digit
                              ? "border-primary bg-primary bg-opacity-10 text-primary"
                              : "border-secondary"
                          }`}
                          style={{
                            width: "38px",
                            height: "48px",
                            fontSize: "1.1rem",
                            borderRadius: "10px",
                            transition: "all 0.2s ease",
                          }}
                          aria-label={`Digit ${index + 1} of 6`}
                        />
                      </Col>
                    ))}
                  </Row>
                </div>
                <div className="position-relative mt-3">
                  <input
                    className="form-control p-2"
                    type={visibility ? "text" : "password"}
                    placeholder="Password"
                    ref={passwordRef}
                    style={{ paddingRight: "40px" }}
                  />
                  <span
                    className="position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer"
                    onClick={toggleVisibility}
                  >
                    {visibility ? <EyeOff size={20} /> : <Eye size={20} />}
                  </span>
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                  )}
                </div>
                <div className="position-relative mt-3">
                  <input
                    className="form-control p-2"
                    type={conformvisibility ? "text" : "password"}
                    placeholder="Confirm Password"
                    ref={confirmPasswordRef}
                    style={{ paddingRight: "40px" }}
                  />
                  <span
                    className="position-absolute end-0 top-50 translate-middle-y me-3 cursor-pointer"
                    onClick={toggleConformVisibility}
                  >
                    {conformvisibility ? (
                      <EyeOff size={20} />
                    ) : (
                      <Eye size={20} />
                    )}
                  </span>
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                  )}
                </div>
                {error && (
                  <Alert
                    variant="danger"
                    className="d-flex align-items-center mb-3 py-2"
                  >
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    <small>{error}</small>
                  </Alert>
                )}
                {timerActive && timeLeft > 0 && (
                  <div className="text-center mb-3">
                    <small className="text-muted">
                      Resend code in {formatTime(timeLeft)}
                    </small>
                  </div>
                )}
                <Button
                  variant="primary"
                  size="md"
                  className="w-100 py-2 mt-3 fw-semibold mb-3 otp-btn-anim"
                  style={{ borderRadius: "12px" }}
                  onClick={changePassword}
                  disabled={otp.join("").length !== 6 || isLoading}
                >
                  {isLoading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      Verifying...
                    </>
                  ) : (
                    "Submit"
                  )}
                </Button>
                <div className="text-center mb-3">
                  <small className="text-muted">
                    Didn't receive the code?{" "}
                  </small>
                  <Button
                    variant="link"
                    className="p-0 fw-semibold text-decoration-none"
                    onClick={handleResend}
                    disabled={timerActive}
                    style={{ fontSize: "0.875rem" }}
                  >
                    Resend Code
                  </Button>
                  {resendCount > 0 && (
                    <div className="mt-1">
                      <small className="text-muted">
                        Code resent {resendCount} time
                        {resendCount > 1 ? "s" : ""}
                      </small>
                    </div>
                  )}
                </div>
                <div className="mb-2 text-center">
                  <small className="text-muted">
                    Entered OTP: <b>{otp.join("")}</b>
                  </small>
                </div>
                <div className="bg-light p-3 rounded-3">
                  <p
                    className="text-center text-muted mb-0"
                    style={{ fontSize: "0.75rem" }}
                  >
                    🔒 Your information is secure and encrypted
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <div
        style={{
          position: "absolute",
          inset: 0,
          opacity: 0.015,
          pointerEvents: "none",
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgb(139, 92, 246) 1px, transparent 0)",
          backgroundSize: "20px 20px",
        }}
      ></div>
    </div>
  );
};

export default OtpPage ;
